/* Purpose: Second level navbar for any client portal page
 * Props: 
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import { ToastHeader} from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const PortalNavBar = () => { 
    const currentLocation = window.location.pathname.substring(8);

    return (
    <>
    <Navbar bg="light" data-bs-theme="light">
      <Container>
        <Navbar.Brand href="/">
                      <ToastHeader><strong>Client Portal</strong></ToastHeader>
        </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link className = "m5" href="/Portal/General">{currentLocation == "General"?<span className='current-location'>General</span>:"General"}</Nav.Link>
            <Nav.Link className = "m5" href="/Portal/Loans">{currentLocation == "Loans"?<span className='current-location'>Loans</span>:"Loans"}</Nav.Link>
            <Nav.Link className = "m5" href="/Portal/Review">{currentLocation == "Review"?<span className='current-location'>Review</span>:"Review"}</Nav.Link>
          </Nav>
      </Container>
    </Navbar>
    </>      
    );
}

export default PortalNavBar;